import { makeStyles } from '@mui/styles';

const useTraitsListItemStyle = makeStyles(() => ({
  button: {
    height: 48,
    width: 150,
  },
  gridItemWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
}));

export default useTraitsListItemStyle;
